// Mirrors themes in npm-packages landing-page-ui/src/theme/themes.ts, which admin cannot import (needs React 19).
export const landingPageThemes = [
  {
    id: 'clean-studio',
    name: 'Clean studio',
    descriptor: 'White and minimal, with crisp lines',
  },
  {
    id: 'soft-editorial',
    name: 'Soft editorial',
    descriptor: 'Warm off-white with soft, rounded cards',
  },
  {
    id: 'bold-athletic',
    name: 'Bold athletic',
    descriptor: 'Dark, condensed type and sharp edges',
  },
  {
    id: 'warm-classic',
    name: 'Warm classic',
    descriptor: 'Cream tones and elegant serif headlines',
  },
  {
    id: 'night-class',
    name: 'Night class',
    descriptor: 'Dark and moody, with rounded shapes',
  },
  {
    id: 'coach-lab',
    name: 'Coach lab',
    descriptor: 'Cool grey with a technical feel',
  },
] as const;

export type LandingPageThemeId = (typeof landingPageThemes)[number]['id'];
